import { ArrowLeft } from 'lucide-react';

export default function TermsPage() {
  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      color: '#e0e0e0',
      fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
    }}>
      {/* Header */}
      <header style={{
        padding: '1rem 2rem',
        borderBottom: '1px solid #1a1a1a',
        display: 'flex',
        alignItems: 'center',
        gap: '1rem'
      }}>
        <a
          href="/"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            color: '#888',
            textDecoration: 'none',
            fontSize: '0.9rem'
          }}
        >
          <ArrowLeft size={18} />
          Back to Home
        </a>
      </header>

      {/* Content */}
      <main style={{
        maxWidth: '800px',
        margin: '0 auto',
        padding: '3rem 2rem'
      }}>
        <h1 style={{
          fontSize: '2.5rem',
          fontWeight: '700',
          marginBottom: '0.5rem',
          color: '#fff'
        }}>
          Terms & Conditions
        </h1>
        <p style={{ color: '#666', marginBottom: '3rem' }}>
          Last updated: January 23, 2026
        </p>

        <div style={{ lineHeight: '1.8', color: '#aaa' }}>
          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              1. Agreement to Terms
            </h2>
            <p>
              By accessing or using Work Van ("Service"), you agree to be bound by these Terms & Conditions.
              If you disagree with any part of these terms, you may not access the Service.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              2. Description of Service
            </h2>
            <p>
              Work Van is a field service management platform that provides tools for managing customers,
              scheduling jobs, creating quotes and invoices, processing payments, and communicating with clients.
              The Service is provided on a subscription basis.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              3. User Accounts
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              When you create an account with us, you must provide accurate, complete, and current information.
              You are responsible for safeguarding the password and for all activities that occur under your account.
            </p>
            <p>
              You agree to notify us immediately of any unauthorized access or use of your account.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              4. Subscription and Payments
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              Some features of the Service require a paid subscription. By subscribing, you agree to pay
              the applicable fees. Subscriptions automatically renew unless cancelled before the renewal date.
            </p>
            <p>
              We reserve the right to change subscription fees with 30 days notice. Refunds are provided
              in accordance with our refund policy.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              5. Acceptable Use
            </h2>
            <p style={{ marginBottom: '1rem' }}>
              You agree not to use the Service for any unlawful purpose or in any way that could damage,
              disable, or impair the Service. You may not attempt to gain unauthorized access to any part
              of the Service.
            </p>
            <p>
              You are solely responsible for all content, data, and information you submit through the Service.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              6. Intellectual Property
            </h2>
            <p>
              The Service and its original content, features, and functionality are owned by Work Van and
              are protected by international copyright, trademark, and other intellectual property laws.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              7. Data and Privacy
            </h2>
            <p>
              Your use of the Service is also governed by our Privacy Policy. By using the Service,
              you consent to the collection and use of information as described in the Privacy Policy.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              8. Limitation of Liability
            </h2>
            <p>
              In no event shall Work Van, its directors, employees, or agents be liable for any indirect,
              incidental, special, consequential, or punitive damages arising from your use of the Service.
              Our total liability shall not exceed the amount you paid us in the 12 months preceding the claim.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              9. Termination
            </h2>
            <p>
              We may terminate or suspend your account immediately, without prior notice, for conduct that
              we believe violates these Terms or is harmful to other users, us, or third parties. Upon
              termination, your right to use the Service will cease immediately.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              10. Changes to Terms
            </h2>
            <p>
              We reserve the right to modify these terms at any time. We will notify users of any material
              changes by posting the new Terms on this page with an updated revision date.
            </p>
          </section>

          <section style={{ marginBottom: '2.5rem' }}>
            <h2 style={{ color: '#fff', fontSize: '1.25rem', marginBottom: '1rem' }}>
              11. Contact Us
            </h2>
            <p>
              If you have any questions about these Terms, please contact us at{' '}
              <a href="mailto:support@workvanapp.com" style={{ color: '#F05A28' }}>
                support@workvanapp.com
              </a>
            </p>
          </section>
        </div>
      </main>

      {/* Footer */}
      <footer style={{
        borderTop: '1px solid #1a1a1a',
        padding: '2rem',
        textAlign: 'center',
        color: '#666',
        fontSize: '0.85rem'
      }}>
        © 2026 WorkVan. All rights reserved.
      </footer>
    </div>
  );
}
